import { useEffect, useState } from "react";
import { Nav } from "../components/Nav";
import { Insights } from "../components/Insights";
import { Newsletter } from "../components/Newsletter";
import { Footer } from "../components/Footer";

export default function Blog() {
  const [activeCategory, setActiveCategory] = useState("all");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main
      className="bg-[#F1EEE8] text-[#232326] min-h-screen"
      data-testid="blog-page"
    >
      <Nav />
      <div className="pt-32 md:pt-40" />
      <Insights activeCategory={activeCategory} onCategoryChange={setActiveCategory} />
      <Newsletter />
      <Footer />
    </main>
  );
}
